import { NetworkErrorService } from "@app/services/NetworkError.service";
import { PaymentApi } from "@app/services/apiServices/PaymentApi";
import { SpinnerService } from "@app/services/spinner.service";
import { PaymentScheduleApi } from "@app/services/apiServices/PaymentScheduleApi";
import { PaymentSchedule } from "@app/models/PaymentSchedule";
import { Property } from "@app/models/Property";
import { PaymentSuccessInfo } from "@app/models/PaymentSuccessInfo";
import { PaymentStore } from "@app/services/stores/PaymentStore";
import { UtilService } from "@app/services/Util.service";
import { UserStore } from "@app/services/stores/UserStore";
import { take } from "rxjs/operators";
import { Component, Inject, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";

@Component({
    selector: 'app-schedule-confirmation',
    template: require('./scheduleconfirmation.component.html')
})
export class ScheduleConfirmationComponent implements OnInit {
    paymentScheduleRequest: PaymentSchedule;
    paymentSuccessInfo: PaymentSuccessInfo;
    property: Property;
    tcCheckbox: boolean;
    convenienceFee: number;
    accountBalance: boolean;
    $stateParams: any;
    accountBalanceAdminFee: number;
    amountType: string;

    constructor(
        @Inject(MatDialog) private dialog: MatDialog,
        @Inject(PaymentScheduleApi) private paymentScheduleApi: PaymentScheduleApi,
        @Inject(PaymentApi) private paymentApi: PaymentApi,
        @Inject(SpinnerService) private spinnerService: SpinnerService,
        @Inject(NetworkErrorService) private networkErrorService: NetworkErrorService,
        @Inject(PaymentStore) private paymentStore: PaymentStore,
        @Inject(UtilService) private utilService: UtilService,
        @Inject(UserStore) private userStore: UserStore,
        @Inject(Router) private router: Router) {

        if(this.router.getCurrentNavigation()) {
            this.$stateParams = this.router.getCurrentNavigation().extras.state;
        }
    }

    ngOnInit() {
        if (this.$stateParams && this.$stateParams.paymentScheduleRequest) {
            this.paymentScheduleRequest = this.$stateParams.paymentScheduleRequest;
        } else if (this.paymentStore.getPaymentScheduleRequest()) {
            this.paymentScheduleRequest = this.paymentStore.getPaymentScheduleRequest();
        } else {
            this.router.navigateByUrl('/properties');
        }

        if (this.$stateParams && this.$stateParams.convenienceFee) {
            this.convenienceFee = this.$stateParams.convenienceFee;
        } else if (this.paymentStore.getConvenienceFee()) {
            this.convenienceFee = this.paymentStore.getConvenienceFee();
        }

        if (this.$stateParams && this.$stateParams.property) {
            this.property = this.$stateParams.property;
        } else if (this.paymentStore.getProperty()) {
            this.property = this.paymentStore.getProperty();
        }

        if (this.$stateParams && this.$stateParams.accountBalanceAdminFee !== undefined) {
            this.accountBalanceAdminFee = this.$stateParams.accountBalanceAdminFee;
        }
        if (this.$stateParams && this.$stateParams.amountType !== undefined) {
            this.amountType = this.$stateParams.amountType;
        }
        this.accountBalance = this.paymentScheduleRequest.type === 'account-balance';
    }

    submit() {
        this.spinnerService.showSpinner();
        this.paymentScheduleRequest.acceptedAmounts = this.tcCheckbox;
        this.paymentScheduleRequest.acceptedAmountsDate = new Date().toISOString().slice(0, 10);

        // paymentMethod is not needed in paymentScheduleRequest
        delete this.paymentScheduleRequest.paymentMethod;

        const userEmail = this.userStore.getEmail()

        this.paymentScheduleApi.paymentSchedulesCreatePost(this.paymentScheduleRequest)
            .pipe(take(1)).subscribe((resp) => {
                this.spinnerService.closeSpinner();
                if (resp.id) {
                    this.paymentSuccessInfo = {
                        paymentId: resp.id,
                        paymentType: "schedule",
                        paymentScheduleRequest: this.paymentScheduleRequest,
                        totalPaymentAmount: resp.futurePayments[0].total,
                        paymentDate: resp.startDate,
                        email: userEmail,
                        confirmationNumber: resp.confirmationNumber,
                        property: this.property,
                        scheduleInfo: {
                            scheduleName: resp.nickname,
                            endDate: resp.endDate,
                            frequency: this.toTitleCase(resp.frequency),
                            numberOfPayments: resp.remainingPayments,
                        }
                    };
                    this.paymentStore.clearAll();
                    this.paymentStore.setPaymentSuccessInfo(this.paymentSuccessInfo)
                    this.router.navigateByUrl('/properties/' + this.paymentSuccessInfo.property.id + '/paymentSuccess',
                        { state: { propertyId: this.paymentSuccessInfo.property.id } });
                } else {
                    throw new Error("Unexpected error behind gateway when creating your schedule. Please reach out to First Citizens Bank if this error persists.")
                }
            }, (err) => {
                this.networkErrorService.handleNetworkError(err, true)
                    .pipe(take(1)).subscribe((resp) => {
                        if (resp === true) {
                            this.submit();
                        }
                    });
            });
    }

    toTitleCase(string) {
        return this.utilService.toTitleCase(string);
    }

    //todo: handle going back to the payment setup screen.
}
